import { ScenarioStateContext } from '@inbox-demo-nx/types';
import { delay } from '@inbox-demo-nx/utils';
import {
  MainAppMessageTypes,
  ParentMessageTypes,
} from '@inbox-demo-nx/web-demo-constants';
import { Platform } from 'react-native';

export async function switchFromMainAppToSupportApp({
  context,
  fallbackDelay = 6000,
  nextState,
}: {
  context: ScenarioStateContext;
  fallbackDelay?: number;
  nextState: string;
}) {
  if (Platform.OS === 'web' && window.self !== window.parent) {
    // the app is in iframe
    await delay(1000);
    window.parent?.postMessage(
      { type: ParentMessageTypes.SHOW_SUPPORT_APP },
      '*'
    );

    function messageHandler(event: WindowEventMap['message']) {
      if (event.data === MainAppMessageTypes.CONTINUE_CONVERSATION) {
        context.transitionState(nextState);
        window.removeEventListener('message', messageHandler);
      }
    }
    window.addEventListener('message', messageHandler);
  } else {
    await delay(fallbackDelay);
    context.transitionState(nextState);
  }
}
